import {WalletContext} from '#/contexts/wallet-provider';
import {useUserProfileLoginMutation} from '#/hooks/mutation/use-user-profile-login-mutation';
import {useContext, useEffect} from 'react';

export const useApiLogin = () => {
  const {
    accountResult: {address: account},
    web3Auth,
    web3AuthSignatureResult: {data: web3AuthIdTokenGroup},
  } = useContext(WalletContext);

  const {mutate: userProfileLoginMutate} = useUserProfileLoginMutation();

  useEffect(() => {
    if (!(account && web3AuthIdTokenGroup && web3Auth?.connected)) {
      return;
    }

    userProfileLoginMutate(web3AuthIdTokenGroup);
  }, [account, userProfileLoginMutate, web3Auth?.connected, web3AuthIdTokenGroup]);
};
